import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddInterpreterService {

  constructor(private httpClient: HttpClient) { }

  getLanguages() { 
    return this.httpClient.get<any>(`/referenceLibrary/LANGUAGE`).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  } 
  
  filteredInterpreterList(companyId:number=0, userId:number=0) { 
    return this.httpClient.get<any>(`/petitioninterpreter/${companyId}/${userId}`).pipe(
      map((response: any) => {
        return response.data;
      })
      )
    } 
    
   interpreterList(langId,employeeId) { 
      return this.httpClient.get<any>(`/petitioninterpreter/interpreternames/${langId}/${employeeId}`).pipe(
        map((response: any) => {
          return response.data;
        })
        )
      }
    
}
